import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

interface ComponentProps extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    label: string;
}

function FormInput({ label, ...inputProps }: ComponentProps) {
    return (
        <div className="form-input-wrapper">
            <input
                {...inputProps}
                placeholder=" "
                className="form-input"
            />
            <label
                className="form-input-label"
                htmlFor={inputProps.id}>
                {label}
            </label>
        </div>
    );
}

export default FormInput;
